var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.image)?_c('ResponsiveImage',{directives:[{name:"animate",rawName:"v-animate",value:(_vm.animate),expression:"animate"}],staticClass:"cut-out",class:_vm.classes,attrs:{"image":_vm.image,"sizes":_vm.sizes,"fitMode":'pad'}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }